const Icon = (props: any) => {
    return (
        <svg width={19} height={24} viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                clipRule="evenodd"
                d="M1 13.966v-.24c.033-.713.24-1.404.602-2.001A5.563 5.563 0 002.796 9.18c0-.733 0-1.477.058-2.21C3.154 3.44 6.327 1 9.46 1h.078c3.133 0 6.306 2.44 6.617 5.97.058.733 0 1.477.048 2.21a5.66 5.66 0 001.193 2.555c.365.592.573 1.28.602 1.99v.23a4.172 4.172 0 01-.844 2.63c-.748.862-1.763 1.399-2.853 1.508-3.195.377-6.419.377-9.614 0-1.089-.114-2.102-.65-2.853-1.508a4.218 4.218 0 01-.834-2.619z"
                stroke="currentColor"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity={0.4}
                d="M7.055 21.736c.5.69 1.233 1.136 2.038 1.24a2.889 2.889 0 002.25-.685c.196-.16.372-.346.524-.555"
                stroke="currentColor"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Icon;
